import logo from '../../../images/logoWhite.png';
import { LANDING_PAGE_URI } from '../../../constants';

export const PageNotExist = () => {
    return (
        <article id='pageNotExist' className='maintenancePage'>
            <div className='newLogo'>
                <a href={LANDING_PAGE_URI as string}>
                    <img src={logo} alt="logo" className='logo' />
                </a>
            </div>
            <div className='container'>
                <h1>Stránka neexistuje</h1>
                <a href={LANDING_PAGE_URI as string} className='returnHome'>
                    Návrat domov
                </a>
            </div>
        </article>
    )
};